import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "./styles/css/fontawesome.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "./styles/css/selectize.css";
import "./styles/css/owl.carousel.css";
import "./styles/css/owl.theme.css";
import "./styles/css/owl.transitions.css";
import "./styles/css/materialdesignicons.min.css";
import "./styles/scss/style.scss";
// import i18n (needs to be bundled ;))
import "./i18n";

ReactDOM.render(<App />, document.getElementById("root"));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
